import { List, Record } from '@gonfalon/immutable-shim/immutableShim';

import type { Hunk } from '#utils/codeRefs/types';

export class HunkRecord extends Record<Hunk>({
  startingLineNumber: 0,
  lines: '',
  projKey: '',
  flagKey: '',
  aliases: List(),
  sourceLink: '',
}) {
  linkLineNumber() {
    let idx = this.lines.split('\n').findIndex((line) => line.includes(this.flagKey));
    if (idx === -1) {
      // not found i.e.  no context lines
      idx = 0;
    }
    return idx + this.startingLineNumber;
  }
}
